<template>
  <div>
	  <div class="row">
		  <div class="col-lg-12">
			  <h1 class="page-header">Flächenverwaltung</h1>
		  </div>
	  </div>

	  <graveyard-select></graveyard-select>

	  <div class="row">
		  <div class="col-lg-12">
				<!-- <div style="border: 1px solid black" v-for="area in $store.getters.allAreas">{{ area.name }}</div> -->
				<!-- <div style="border: 1px solid black">{{ $store.getters.allAreas[0].name }}</div> -->
				<map-marker></map-marker>
		  </div>
	  </div>

	  <custom-table :sendCriteria="true" @criteriaChange="newCriteria" @modelChange="newAreas" edit="/areas/{:id}" :criteria="criteria" add="/areas/new" :default-sort="defSort" search @print="print" :src-model="this.$store.getters.models('areas')" :cols="cols"></custom-table>
  </div>
</template>

<script>
import CustomTable from 'components/custom-table.vue'
import GraveyardSelect from 'components/graveyard-select.vue'
import MapMarker from 'components/map-marker.vue'

import moment from 'moment'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
  beforeRouteEnter (to, from, next) {
    const route = authCheck('areas')
    if (route === null) {
      next()
    } else {
      next(route)
    }
  },

	name: 'app',
	data () {
		return {
			pAreas: [{coordinates: "52 40.614,8 48.757"}],

			myCriteria: {},

			criteria: [
				{
					'name': 'Name',
					'json': 'name'
				},
				{
					'name': 'Kategorie (Kurz)',
					'json': 'short_name'
				},
				{
					'name': 'Kategorie (Lang)',
					'json': 'category_name'
				},
				{
					'name': 'Preis',
					'json': 'real_price'
				},
				{
					'name': 'Status',
					'json': 'status'
				},
				{
					'name': 'Buchung',
					'json': 'summary'
				},
				{
					'name': 'Verstorbene',
					'json': 'deceased_count'
				}
			],

			cols: [
				{
					'name': 'Name',
					'json': 'name',
					'type': 'text'
				},
				{
					'name': 'Kategorie',
					'json': 'short_name',
					'type': 'text',
					'hint': 'Es kann nach der Kurzform, aber auch nach der Langform gesucht werden.'
				},
				{
					'name': 'Preis',
					'json': 'real_price',
					'type': function(aValue, aColumn, aModel) {
						// console.log(aValue, aColumn, aModel);
						return aValue > 0 ? [ aValue.toString() + ' €' ] : null
					}
				},
				{
					'name': 'Buchung',
					'json': 'summary',
					'type': 'text',
					css (aValue, aCol, aModel) {
						// console.log(aModel.grave_count)
						// console.log(aModel.customer_count)
						if (parseInt(aModel.grave_count) === 0) {
							return 'btn btn-primary'
						} else if (parseInt(aModel.customer_count) === 0) {
							return 'btn btn-success'
						} else if (parseInt(aModel.customer_count) === parseInt(aModel.grave_count)) {
							return 'btn btn-danger'
						} else {
							return 'btn btn-warning'
						}
					},
					'hint': 'Suchen/Filtern:<br>[Teilbelegt]<br>[Vergeben]<br>[Frei]<br>[Keine Gräber]<br>möglich'
				},
				{
					'name': 'Verstorbene',
					'json': 'deceased_count',
					'type': 'int',
					css: {
						default: 'btn btn-danger',
						0: 'btn btn-success'
					}
				}
			],
			defSort: { col: 'id', order: 'asc' }
		}
	},

	computed: {
		areas: {
			get () {
				console.log("Areas Requested")
				return this.pAreas
			},

			set (aNewModel) {
				console.log("Setting Areas", aNewModel)
				this.pAreas = aNewModel
			}
		}

		/* geoLocation () {
			return this.calcGeoLocation(this.$store.getters.allAreas[0].coordinates)
		},*/

		/*areas () {
			console.log("AREAS", this.$refs.myareas, this.$refs.mymap)

			if (typeof this._areas === "undefined") {
				return [{coordinates: "52 40.614,8 48.757"}]
			}

			return this._areas
		}*/
	},

	components: {
		'graveyard-select': GraveyardSelect,
		'custom-table': CustomTable,
		MapMarker
	},

	activated () {
		//console.log("ACTIVATED", this.$refs.mymap)
		//this.$refs.mymap.resizePreserveCenter()

		this.$store.dispatch('loadModel', 'areas')
		.then(response => {
			//
		})
	},

	methods: {
		newCriteria (aCriteria) {
			console.log(aCriteria)
			// this.myCriteria = aCriteria
			this.$store.commit("criteria", aCriteria)
		},

		newAreas (aAreas) {
			console.log(aAreas)
			// this.pAreas = aAreas
		},

		createNewModels(aModels) {
			let result = []
			for (let Key in aModels) {
				result.push(aModels[Key])
			}
			return result
		},

		onAllModels (aAreas) {
			//let lAreas = aAreas
			let lAreas = this.$refs.myareas.allModels
			console.log(lAreas)
			if (Array.isArray(lAreas) && lAreas.length > 0) {
				console.log("Set Models")
				this.areas = lAreas.map(item => item)
			}
			//console.trace()
		},

		calcIcon (aArea) {
			// var SuffixIndex = ["[Vergeben]", "[Teilbelegt]", "[Frei]", "[Keine Gräber]"].indexOf(aArea.status)
			/* return {
			 "url": "/img/icons/black_blue.svg",
			 "size":  new google.maps.Size(25, 25),
			 "scaledSize": new google.maps.Size(25, 25)
			 } */
			//return "https://dev.w3.org/SVG/tools/svgweb/samples/svg-files/android.svg"
			switch (aArea.short_name) {
				case "BEE":
					return {
						"url": "/img/icon_blau.png"
					}

				case "BAG":
					return {
						"url": "/img/icon_weis.png"
					}

				case "BBG":
					return {
						"url": "/img/icon_weis.png"
					}

				case "BEG":
					return {
						"url": "/img/icon_weis.png"
					}

				case "BFG":
					return {
						"url": "/img/icon_weis.png"
					}

				default:
					return {
						"url": "/img/icon_gruen.png"
					}
			}
		},

		print (aModels) {
			aModels[0] = aModels[0].map(aValue => {
				return {text: aValue, style: 'tableHeader', alignment: 'center'}
			})

			let dd = {
				header: {
					columns: [
						{
							text: '',
							alignment: 'center',
							style: 'header'
						},
						{
							text: 'Flächenübersicht',
							alignment: 'center',
							style: 'header'
						},
						{
							text: moment().format('YYYY-MM-DD'),
							alignment: 'right'
							//style: 'header'
						}
					]
				},

				footer (currentPage, pageCount) {
					return {
						text: currentPage + '/' + pageCount,
						alignment: 'center'
					}
				},

				content: [
					{
						table: {
							headerRows: 1,
							widths: ['*', '*', '*', '*', '*'],

							body: aModels
						}
					}
				],
				styles: {
					header: {
						fontSize: 18,
						bold: true,
						margin: [0, 0, 0, 10]
					},
					subheader: {
						fontSize: 16,
						bold: true,
						margin: [0, 10, 0, 5]
					},
					tableExample: {
						margin: [0, 5, 0, 15]
					},
					tableHeader: {
						bold: true,
						fontSize: 13,
						color: 'black'
					}
				}
			}

			pdfMake.createPdf(dd).open()
		},

		googleURL (aURL) {
			return 'https://www.google.de/maps/place/?q="' + aURL + '"'
			//return ['<br>']
		}
	}
}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// AreaOverview.vue?931e7f88